import {
  commonUtil,
  countryUtil,
  countryCallingCodeUtil,
  currencyUtil
} from '@/util'

const areaNameList = [
  'common.input_billing-info',
  'common.input_recipient-info',
  'common.input_sale-info'
]

const interfaceObj = {
  title: '',
  postalCode: '',
  address: '',
  phone: ''
}

function setRegisterInfo(clientData) {
  const register = clientData.client

  const registerInvoice = register.invoiceInfo
  const invoiceInfo = {
    ...interfaceObj,
    title: areaNameList[0],
    name: commonUtil.getSeparateWordsBySpace([
      registerInvoice.organizationName,
      registerInvoice.fullName
    ]),
    postalCode: commonUtil.formatPostalCode(
      registerInvoice.postalCode,
      registerInvoice.country.value
    ),
    address:
      countryUtil.getRegionInfo(
        registerInvoice.country.value,
        commonUtil.getRegionValue(registerInvoice.region)
      ).label +
      commonUtil.getSeparateWordsBySpace([
        registerInvoice.address1,
        registerInvoice.address2
      ]),
    phone: countryCallingCodeUtil.formatPhoneNumber(
      registerInvoice.phone.phoneNumber,
      registerInvoice.phone.countryCode.value,
      false
    )
  }

  const registerReceiver = register.receiverInfo
  const receiverInfo = {
    ...this.interfaceObj,
    title: areaNameList[1],
    name: commonUtil.getSeparateWordsBySpace([
      registerReceiver.organizationName,
      registerReceiver.fullName
    ]),
    postalCode: commonUtil.formatPostalCode(
      registerReceiver.postalCode,
      registerReceiver.country.value
    ),
    address:
      countryUtil.getRegionInfo(
        registerReceiver.country.value,
        commonUtil.getRegionValue(registerReceiver.region)
      ).label +
      commonUtil.getSeparateWordsBySpace([
        registerReceiver.address1,
        registerReceiver.address2
      ]),
    phone: countryCallingCodeUtil.formatPhoneNumber(
      commonUtil.nullEmptyFormat(registerReceiver.phone.phoneNumber, ''),
      registerReceiver.phone.countryCode.value,
      false
    )
  }

  const requiredInfo = register.saleInfo
  const sales = {
    ...this.interfaceObj,
    title: areaNameList[2],
    customerName: register.clientInfo.rep,
    organizationName: register.clientInfo.organizationName,
    shopName: register.clientInfo.shopName,

    currency: currencyUtil.getCurrencyIdInfo(requiredInfo.currency.value),
    saleDate: requiredInfo.saleDate
  }

  return [invoiceInfo, receiverInfo, sales]
}

function setHistoryInfo(history) {
  const invoiceInfo = {
    ...interfaceObj,
    title: areaNameList[0],
    name: commonUtil.getSeparateWordsBySpace([
      history.billingOrganizationName,
      history.billingName
    ]),
    postalCode: commonUtil.formatPostalCode(
      history.billingPostalCode,
      history.billingAddressCountryId
    ),
    address:
      countryUtil.getRegionInfo(
        history.billingAddressCountryId,
        history.billingRegionId
      ).label +
      commonUtil.getSeparateWordsBySpace([
        history.billingAddress1,
        history.billingAddress2
      ]),
    phone: countryCallingCodeUtil.formatPhoneNumber(
      history.billingPhoneNumber,
      history.billingPhoneNumberCountryId,
      false
    )
  }

  const receiverInfo = {
    ...this.interfaceObj,
    title: areaNameList[1],
    name: commonUtil.getSeparateWordsBySpace([
      history.recipientOrganizationName,
      history.recipientName
    ]),
    postalCode: commonUtil.formatPostalCode(
      history.recipientPostalCode,
      history.recipientAddressCountryId
    ),
    address:
      countryUtil.getRegionInfo(
        history.recipientAddressCountryId,
        history.recipientRegionId
      ).label +
      commonUtil.getSeparateWordsBySpace([
        history.recipientAddress1,
        history.recipientAddress2
      ]),
    phone: countryCallingCodeUtil.formatPhoneNumber(
      commonUtil.nullEmptyFormat(history.recipientPhoneNumber, ''),
      history.recipientPhoneNumberCountryId,
      false
    )
  }

  const sales = {
    ...this.interfaceObj,
    title: areaNameList[2],
    customerName: history.customer.rep,
    organizationName: history.customer.organizationName,
    shopName: history.customer.shopName,
    currency: currencyUtil.getCurrencyIdInfo(history.currencyId),
    saleDate: history.saleDate
  }

  return [invoiceInfo, receiverInfo, sales]
}

export default { setRegisterInfo, setHistoryInfo }
